/* globals require document */

import $ from "jquery";
import Vue from "vue";
import EventBus from "../../../common/image-viewer/event-bus";
import "../../../common/image-viewer/image-viewer";
import { trans } from "common/translate.js";
import { bindCommentsOverlay } from "../commentsOverlay.js";
import expando from "./expando.js";

$(() => {
  bindCommentsOverlay();

  // Image page
  // TODO - see if it can be changed into a static import
  require("./image-page.js");

  // Expand/collapse on small screens
  new Vue({
    // TODO - add manuscript list as well
    el: "#js-metadata-expando",
    components: {
      expando
    }
  })

  // Hydrate fragments list on large screens
  // This fragment list interacts with the image viewer
  if (document.querySelector("#js-fragments-list")) {
    new Vue({
      el: "#js-fragments-list",
      methods: {
        onHover() {
          EventBus.$emit("fragmentList.focus");
        },

        onLeave(){
          EventBus.$emit("fragmentList.blur");
        },

        onFragHover(index) {
          EventBus.$emit("fragmentList.fragment.focus", index);
        }
      }
    });
  }

  // Hydrate the image viewer container
  new Vue({
    el: "#js-image-viewer-container"
  });
});



// WEBPACK FOOTER //
// ./src/frontend/pages/explore-the-archive/image/image.js